import { SocialPlatform } from '@/lib/api';

const PLATFORM_LABELS: Record<SocialPlatform, string> = {
  twitter: 'X / Twitter',
  linkedin: 'LinkedIn',
  facebook: 'Facebook',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  telegram: 'Telegram',
};

interface PlatformBadgeProps {
  platform: SocialPlatform;
  size?: 'sm' | 'md';
}

export function PlatformBadge({ platform, size = 'sm' }: PlatformBadgeProps) {
  const label = PLATFORM_LABELS[platform];
  const sizeClass = size === 'sm' ? 'text-xs px-1 py-0.5' : 'text-sm px-3 py-1';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${sizeClass}`}>
      {label}
    </span>
  );
}
